import { UserContext } from "context/UserContext";
import { useProviderInitializedContext } from "hooks/useProviderInitializedContext";

export const useUser = () => useProviderInitializedContext(UserContext);
